import { ArrowRight } from "lucide-react";
import { siteConfig } from "../../../config/site";
import { Badge } from "../ui/Badge";
import { Button } from "../ui/Button";
import { PreviewChallengeCard } from "./PreviewChallengeCard";

const chips = ["30 ερωτήσεις", "8–12 λεπτά", "Adaptive δυσκολία", "Αναλυτικό report"];

export function HeroSection() {
  return (
    <section className="relative mx-auto grid min-h-[calc(100svh-4rem)] w-full max-w-6xl content-center gap-8 px-4 py-10 sm:px-6 md:grid-cols-[1.05fr_0.95fr] md:items-center lg:gap-12 lg:py-14">
      <div className="pointer-events-none absolute -left-20 top-10 h-72 w-72 rounded-full bg-cyan-300/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-32 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
      <div className="relative z-10">
        <Badge>IQ-style Logic Challenge • 8–12 λεπτά • Adaptive</Badge>
        <h1 className="mt-5 max-w-3xl text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl">{siteConfig.headline}</h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-slate-300 sm:text-lg">{siteConfig.subheadline}</p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Button href="/test" className="w-full sm:w-auto">
            Ξεκίνα το IQ Test <ArrowRight className="ml-2" size={18} />
          </Button>
        </div>
        <p className="mt-3 text-sm text-slate-300">30 ερωτήσεις • 8–12 λεπτά • χωρίς λογαριασμό για να ξεκινήσεις</p>
        <div className="mt-6 flex flex-wrap gap-2.5">
          {chips.map((chip) => (
            <span key={chip} className="rounded-full border border-cyan-200/15 bg-white/[0.065] px-3.5 py-2 text-xs font-semibold text-slate-200 shadow-[inset_0_1px_0_rgb(255_255_255_/_0.05)]">
              {chip}
            </span>
          ))}
        </div>
        <p className="mt-5 max-w-2xl text-xs leading-5 text-slate-400">
          Η αναφορά επίδοσης παρουσιάζεται για προσωπική χρήση, κατανόηση προφίλ απαντήσεων και σύγκριση προόδου.
        </p>
      </div>
      <div className="relative z-10">
        <PreviewChallengeCard />
      </div>
    </section>
  );
}
